var _path, _mask, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7V3C6 1.89543 6.89543 1 8 1H14C15.1046 1 16 1.89543 16 3V7",
    stroke: "currentColor",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C0.895431 6 0 6.89543 0 8V14H22V8C22 6.89543 21.1046 6 20 6H2ZM22 15H0V18C0 19.1046 0.89543 20 2 20H20C21.1046 20 22 19.1046 22 18V15Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C0.895431 6 0 6.89543 0 8V14H22V8C22 6.89543 21.1046 6 20 6H2ZM22 15H0V18C0 19.1046 0.89543 20 2 20H20C21.1046 20 22 19.1046 22 18V15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14H-1V15H0V14ZM22 14V15H23V14H22ZM22 15H23V14H22V15ZM0 15V14H-1V15H0ZM1 8C1 7.44772 1.44772 7 2 7V5C0.343146 5 -1 6.34315 -1 8H1ZM1 14V8H-1V14H1ZM0 15H22V13H0V15ZM21 8V14H23V8H21ZM20 7C20.5523 7 21 7.44772 21 8H23C23 6.34315 21.6569 5 20 5V7ZM2 7H20V5H2V7ZM22 14H0V16H22V14ZM1 18V15H-1V18H1ZM2 19C1.44772 19 1 18.5523 1 18H-1C-1 19.6569 0.343145 21 2 21V19ZM20 19H2V21H20V19ZM21 18C21 18.5523 20.5523 19 20 19V21C21.6569 21 23 19.6569 23 18H21ZM21 15V18H23V15H21Z",
    fill: "currentColor",
    mask: "url(#path-2-inside-1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.8c9198a6.svg";
export { ForwardRef as ReactComponent };